import Modal from '@src/components/modal';
import React, { useCallback, useRef } from 'react';
import { noop } from '@src/utils/common-util.js';
import useUnmount from '@src/utils/hooks/use-unmount';

const useModal = (Component, { store = {}, ...settings }, antdProps = {}) => {
  const ref = useRef(noop);
  const open = useCallback(
    ({ extraProps = {}, extraStore = {} } = {}) => {
      ref.current();
      ref.current = Modal.append(props => (
        <Modal centerContent visible={props.visible} onClose={props.onClose} afterClose={props.afterClose} {...antdProps}>
          <Component
            onClose={props.onClose}
            store={Object.assign(store, extraStore)}
            {...settings || {}}
            {...extraProps}
            {...extraProps}
            modalContainerVisible={props.visible}
          />
        </Modal>
      )).close;
      return ref.current;
    },
    [settings]
  );
  useUnmount(() => {
    ref.current();
  });
  const close = useCallback(() => ref.current(), []);
  return { open, close };
};

export default useModal;
